module.exports = __webpack_public_path__ + "img/t2-11.5e0c3f88.svg";